const toCamel = snakeString => snakeString.replace(/(_\w)/g, match => match[1].toUpperCase())
const toSnake = camelString => camelString.replace(/[\w]([A-Z])/g, match => match[0] + '_' + match[1].toLowerCase())

function switchCase(value, changeCaseFunction) {
  if (value === null || typeof value !== 'object') { // pass on null and shallow values
    return value
  }

  if (Array.isArray(value)) { // recursively transform array value
    return value.map(value => switchCase(value, changeCaseFunction))
  } else { // recursively transform objects
    const newValue = {}
    Object.entries(value).forEach(entry => {
      const [key, value] = entry
      newValue[changeCaseFunction(key)] = switchCase(value, changeCaseFunction)
    })
    return newValue
  }
}

export const objectToCamelCase = object => switchCase(object, toCamel)
export const objectToSnakeCase = object => switchCase(object, toSnake)
